import { IonContent, IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { NestedPageHeader } from '../../components/header/page.header';
import { TenantExport } from '../../components/tenant/tenant-export';
import { useBeaconRouter } from '../../route/route.hooks';
import { useActiveWorkspace } from '../../store/workspace/workspace.hooks';

const TenantExportPage = (): ReactElement => {
  const { i18n } = useTranslation();
  const workspace = useActiveWorkspace();
  const { builder } = useBeaconRouter();

  let pageName: string = i18n.t('common:data_export');
  if (workspace?.tenant.name) {
    pageName = `${workspace.tenant.name} ${i18n.t('common:data_export')}`;
  }

  return (
    <IonPage>
      <NestedPageHeader
        title={pageName}
        defaultBackRoute={builder.getAdminRoute()}
      />
      <IonContent>
        <TenantExport />
      </IonContent>
    </IonPage>
  );
};

export { TenantExportPage };
